import React from 'react';
import { PropTypes } from 'prop-types';
import { Tooltip, Typography } from '@mui/material';

const GenericTooltipCell = ({ data }) => (
  <Tooltip title={data} sx={{ overflow: 'hidden' }}>
    <Typography>{data}</Typography>
  </Tooltip>
);

GenericTooltipCell.propTypes = {
  data: PropTypes.string.isRequired,
};

export default GenericTooltipCell;
